var _style, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "133.3px",
    height: "256px",
    viewBox: "0 0 133.3 256",
    style: {
      enableBackground: "new 0 0 133.3 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.usage-icon{fill:#FFFFFF;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "usage-icon",
    d: "M130.1,95.4L69.9,103c-1.7,0.2-3.3-1-3.3-2.6l10-97.8c0-3-4.5-3.7-5.6-0.9L0.2,157.1c-0.7,1.9,1,3.8,3.1,3.5l60.1-7.6 c1.7-0.2,3.3,1,3.3,2.6l-10,97.8c0,3,4.5,3.7,5.6,0.9l70.9-155.3C133.9,97.1,132.2,95.2,130.1,95.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricity);
export default __webpack_public_path__ + "static/media/icon-electricity.b988387da0570e943c501e1c8c01a37e.svg";
export { ForwardRef as ReactComponent };